export default class State {

  static getStyle(element, styleProperty) {
    if (window.getComputedStyle) {
        return document.defaultView.getComputedStyle(element, null).getPropertyValue(styleProperty);
    }
    else if (element.currentStyle) {
        return element.currentStyle[styleProperty];
    }

    return null;
  }

  static preventScrolling(prevent = true) {
    document.documentElement.classList.toggle('prevent-scrolling', prevent);
  }

  static isLandscape() {
    return window.innerHeight < window.innerWidth || window.innerWidth >= 800;
  }
}



// WEBPACK FOOTER //
// ./website/assets/scripts/modules/state.js